import React, { useReducer } from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer';

import {
    SUCCESSFULL_REGISTER,
    ERROR_REGISTER,
    GET_USER,
    SUCCESSFULL_LOGIN,
    ERROR_LOGIN,
    LOGOUT
} from '../../types';
import axiosClient from '../../config/axios';
import tokenAuth from '../../config/authToken';

const AuthState = props => {
    
    const initialState = {
        token: localStorage.getItem('token'),
        authenticated: null,
        user: null,
        message: null,
        loading: true
    }

    const [ state, dispatch ] = useReducer(AuthReducer, initialState);

    // Functions
    const userRegister = async userData => {
        try {
            const response = await axiosClient.post('/api/users', userData);
            dispatch({
                type: SUCCESSFULL_REGISTER,
                payload: {
                    token: response.data.token
                }
            });
            // Get the information of the authenticated user
            authenticatedUser();
        } catch (error) {
            const alert = {
                msg: error.response.data.msg,
                category: 'alerta-error'
            }
            dispatch({
                type: ERROR_REGISTER,
                payload: alert
            });
        }
    }

    // Returns the authenticated user
    const authenticatedUser = async() => {
        const token = localStorage.getItem('token');
        if(token){
            // Function to send token via headers
            tokenAuth(token);
        }
        try {
            const response = await axiosClient.get('/api/auth');
            dispatch({
                type: GET_USER,
                payload: response.data.user
            })
        } catch (error) {
            console.log(error);
            dispatch({
                type: ERROR_LOGIN
            });
        }
    }

    // Login for a user
    const loginUSer = async loginData => {
        try {
            const response = await axiosClient.post('/api/auth', loginData);
            console.log(response.data.token);
            dispatch({
                type: SUCCESSFULL_LOGIN,
                payload: {
                    token: response.data.token
                }
            });
            // Get the information of the authenticated user
            authenticatedUser();
        } catch (error) {
            const alert = {
                msg: error.response.data.msg,
                category: 'alerta-error'
            }
            dispatch({
                type: ERROR_LOGIN,
                payload: alert
            });
        }
    }

    // Logout a user
    const logoutUser = () => {
        dispatch({
            type: LOGOUT
        });
    }

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                authenticated: state.authenticated,
                user: state.user,
                message: state.message,
                loading: state.loading,
                userRegister,
                loginUSer,
                authenticatedUser,
                logoutUser
            }}
        >
            { props.children }
        </AuthContext.Provider>
    );
}

export default AuthState;